import * as util from '../apiUtils';
import * as common from '../apiCommon';
import { TAX_GROUP } from '../../constants/constant_doc_types';

export function saveTaxGroup(app, dataToSave) {
  const { user = {}, data } = dataToSave;
  let taxGroupData = {
    doc_type: TAX_GROUP,
    active: util.toBoolean(data.active),
    name: util.toStringText(data.name),
    short_name: util.toStringText(data.short_name),
    system_defined: util.toBoolean(data.system_defined),
  };
  return common.saveDoc(app, {
    source: data,
    doc: taxGroupData,
    user,
  });
}

export function fetchTaxGroupDropdown(app, params) {
  const { searchTerm, searchParams, fields, id } = params;
  const dropdown_type = 'tax_group/dropdown';
  const query = {
    id,
    dropdown_type,
    fields,
    searchTerm,
    searchParams,
  };

  return common.getDropdownList(app, { query });
}

export function deleteTaxGroup(app, data) {
  return common.deleteDoc(app, {
    id: data.id,
    docType: TAX_GROUP,
  });
}

export function fetchTaxGroupById(app, params) {
  const { id } = params;
  const docType = TAX_GROUP;
  return common.getDoc(app, { id, docType });
}

export async function fetchAllTaxGroups(app) {
  const result = await common.queryDocs(app, TAX_GROUP, {
    limit: 1000,
  });

  return result.data;
}
